import { useNavigate } from 'react-router'
import { FileText } from 'lucide-react'
import { ConsumerShell } from '@/consumer/components/consumer-shell'
import { ClaimCard } from '@/consumer/components/claim-card'
import { useConsumerClaims } from '@/consumer/hooks/use-consumer-claims'

// ── Main Page ──────────────────────────────────────────

export default function ClaimsPage() {
  const navigate = useNavigate()
  const { data: claims, isPending } = useConsumerClaims()

  return (
    <ConsumerShell>
      {/* Header */}
      <div className="mb-8">
        <h1 className="clara-title mb-1">My Claims</h1>
        <p className="text-[12px] text-[var(--ink-3)]">
          {claims ? `${claims.length} claim${claims.length !== 1 ? 's' : ''}` : '...'}
        </p>
      </div>
      {/* Loading */}
      {isPending && (
        <div className="flex items-center justify-center py-20">
          <p className="text-[13px] text-[var(--ink-3)]">Loading...</p>
        </div>
      )}
      {/* Claims grid */}
      {!isPending && claims && claims.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {claims.map((c) => (
            <ClaimCard
              key={c.uuid}
              claim={c}
              onClick={() => navigate(`/claims/${c.uuid}`)}
            />
          ))}
        </div>
      )}
      {/* Empty state */}
      {!isPending && claims && claims.length === 0 && (
        <div className="rounded-[8px] border-[0.5px] border-[var(--rule)] bg-[var(--bg-card)] p-16 text-center">
          <div className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[var(--bg-subtle)]">
            <FileText className="h-7 w-7 text-[var(--ink-3)]" />
          </div>
          <h2 className="clara-heading mb-2">No claims</h2>
          <p className="mx-auto max-w-xs text-[12px] text-[var(--ink-3)]">
            When you submit a claim on a product, it will appear here so you can track its progress.
          </p>
        </div>
      )}
    </ConsumerShell>
  );
}
